import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container as Grid } from 'react-bootstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { creators as actionCreators } from '../../actions'
import actionProptypes from '../../actions/proptypes'
import classnames from 'classnames'

import style from './argaErrorBar.css'

class ArgaErrorBar extends Component {
  onContactSupportClick () {
    this.props.actions.contactTechSupport()
  }

  render () {
    const msg = this.props.uiState.isInstructorView
      ? 'Your class roster has not been loaded.'
      : 'Your work in this session will not be saved.'

    const wrapperClass = this.props.isPreview ? style.previewContainer : style.container
    const bumpClass = (this.props.uiState.isInstructorView && !this.props.isPreview) ? style.instructorBump : ''

    return (
      <div className={classnames(wrapperClass, bumpClass)} tabIndex="0">
        <Grid>
          <div className={style.errorMessage1}>Server connection failure!</div>
          <div className={style.errorMessage2}>{msg}</div>
          <div
            className={style.errorMessage3}
            onClick={this.onContactSupportClick.bind(this)}
            tabIndex="0"
          >
            Contact tech support
          </div>
        </Grid>
      </div>
    )
  }
}

ArgaErrorBar.propTypes = {
  uiState: PropTypes.object.isRequired,
  actions: actionProptypes,
  isPreview: PropTypes.bool
}

function mapStateToProps (state, ownProps) {
  return {
    uiState: state.core.uiState
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return { actions: bindActionCreators(actionCreators, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArgaErrorBar)
